<template>
    <div>
        <invoicing-invoice-form-modal />
    </div>
</template>

<script>
    import InvoicingInvoiceFormModal from './Invoice/FormModal.vue';
    
    export default {
        components: {
            InvoicingInvoiceFormModal
        }
    }
</script>